<template>
  <div class="d-flex flex-wrap">
    <v-chip v-for="(filterValue, i) in displayFilters" :key="i"
      color="" size="small" class="ma-1" closable close-icon="mdi-close" @click:close="remove(filterValue)">
      <template #prepend v-if="filterValue.color">
        <v-chip class="filter-status-color ml-n2 me-2" variant="flat" :color="filterValue.color" size="x-small">
          <v-icon class="filter-status-icon" size="small" color="white">mdi-{{filterValue.icon}}</v-icon>
        </v-chip>
      </template>
      {{filterValue.text}}
    </v-chip>
  </div>
</template>

<script setup lang="ts">
import {FilterDisplayItemExtended, StorageStore} from '@/store/types';
import {computed} from 'vue';
import {PropType} from 'vue';

const props = defineProps({
  store: {
    type: Object as PropType<StorageStore<any, any, any>>,
    required: true,
  },
});

const displayFilters = computed((): FilterDisplayItemExtended[] => {
  return props.store.displayFilters;
});

function remove(filter: FilterDisplayItemExtended) {
  props.store.unsetFilter(filter);
}

defineExpose({
  remove,
  displayFilters,
  props,
});
</script>

<style scoped>
  .filter-list-filter-btn {
    margin-left: auto;
    margin-top: auto;
  }

  .filter-status-color {
    width: 20px;
    height: 20px;
    padding: 0 !important;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
